export const CHANGECON_API = import.meta.env.VITE_CHANGECON_API_URL ?? '/api/changecon';
